/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Faq_Q4Inputs */

const en_sorter_faq_q4 = /** @type {(inputs: Sorter_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why sort JSON keys?`)
};

const ko_sorter_faq_q4 = /** @type {(inputs: Sorter_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 키를 정렬하는 이유는?`)
};

const ja_sorter_faq_q4 = /** @type {(inputs: Sorter_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜJSONキーをソートするのですか？`)
};

/**
* | output |
* | --- |
* | "Why sort JSON keys?" |
*
* @param {Sorter_Faq_Q4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_faq_q4 = /** @type {((inputs?: Sorter_Faq_Q4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Faq_Q4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_faq_q4(inputs)
	if (locale === "ko") return ko_sorter_faq_q4(inputs)
	return ja_sorter_faq_q4(inputs)
});